import { Button, ButtonSpinner, ButtonText, cn } from '@vidahealth/vida-ui';
import { ComponentProps } from 'react';

type CtaButtonProps = Omit<ComponentProps<typeof Button>, 'variant'> & {
  children: React.ReactNode;
  isBusy?: boolean;
  /**
   * `primary` (default) is the solid filled pill; `secondary` is an outline pill
   * for a lower-emphasis action — e.g. "See other options" under "Join program".
   */
  type?: 'primary' | 'secondary';
};

export function CtaButton({
  children,
  isBusy,
  type = 'primary',
  className,
  isDisabled,
  ...rest
}: CtaButtonProps) {
  const isPrimary = type === 'primary';
  return (
    <Button
      size='lg'
      variant={isPrimary ? 'solid' : 'outline'}
      className={cn('rounded-full', className)}
      isDisabled={isDisabled}
      {...rest}
    >
      {isBusy ? (
        <ButtonSpinner color={isPrimary ? 'white' : undefined} />
      ) : (
        <ButtonText className={isPrimary ? 'dark:text-primary-0' : undefined}>
          {children}
        </ButtonText>
      )}
    </Button>
  );
}
